export const removeTrailingSlash = url => {
  if (typeof url !== "string") {
    throw new TypeError("Expected a string");
  }

  return url.replace(/\/+$/, ""); // Remove trailing slashes
};

export const replaceMultiple = (str, replacements) => {
  return Object.keys(replacements).reduce(
    (acc, key) => acc.replaceAll(key, replacements[key]),
    str
  );
};

export const removeSpace = str => {
  return str?.toString().replace(/\s+/g, "") || "";
};
